import React, { useState } from 'react'
import { selectSchoolName } from '@landscape/ui-redux'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

const GlyphAfter = styled.div`
  &:before {
    vertical-align: 0.5em;
  }
`

const InstitutionInfo: React.FC = () => {
  const schoolName: string = useSelector(selectSchoolName)

  return (
    <h6 className="cb-margin-top-24 cb-margin-right-32 cb-align-right">
      <span className="cb-glyph-content cb-school cb-margin-right-16 cb-font-size-xsmall" />
      <span className="cb-font-size-small" data-testid="school-name-label">
        {schoolName}
      </span>
    </h6>
  )
}

export { InstitutionInfo }
